import { useMainStore } from "@/store";
import { User } from "@/@types";

export interface SessionServiceInterface {
  saveSession: (params: User) => void;
  getSession: () => User | null;
  updateSession: (params: Partial<User>) => void;
}

export class SessionService implements SessionServiceInterface {
  saveSession = (params: User) => {
    useMainStore().saveSession(params);
  };
  getSession = (): User | null => {
    return useMainStore().session;
  };
  updateSession = (params: Partial<User>) => {
    useMainStore().updateSession(params);
  };
}
